// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_wrapper-news.scss
// module id = 58
// module chunks = 0